<template>
    <v-navigation-drawer width="450px" v-model="drawerVal" app clipped @transitionend="toggleDrawer(drawerVal)">
        <v-list dense>
            <v-subheader>LIST COMPONENTS:</v-subheader>
                <v-list-item class="search_field">
                    <v-list-item-content class="pt-0 pb-0 mb-0 mt-0">
                        <v-list-item-title class="title">
                            <v-text-field
                                :value="searchItem"
                                class="mt-1 project_search"
                                label="SEARCH MASTER"
                                hide-details
                                clearable
                                outlined
                                dense
                                append-icon="mdi-magnify"
                                @keyup="setSearchItem($event.target.value)"
                                @click:clear="setSearchItem(null)"
                            ></v-text-field>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
        
        <!-- DOCUMENT REQUEST MASTER -->  
            <div style="font-family:Arial;font-size:16px;color:#696969;" class="mt-2 ml-2">Document Request Master</div>

                    <!-- HOUSE TYPE MASTER -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(建物タイプ・矩計) Building Type</v-list-item-title>
                        </template>
                            <v-list-item v-for="(houseTypeMaster, aa) in houseType" :key="'houseTypeMaster'+ aa" :to="houseTypeMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="houseTypeMaster.text"> </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <v-list-item
                        v-for="(item, i) in masterList"
                        :key="'item'+i"
                        :href="item.to"
                        link>
                    <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.text">
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- SASH MASTER LIST -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(サッシ) Sash</v-list-item-title>
                        </template>
                            <v-list-item v-for="(sashMaster, v) in sash" :key="'sashMaster'+v" :to="sashMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="sashMaster.text"> </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <!-- COLOR LAYOUT DRAWING MASTER -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(カラー配置図) Color Layout Drawing</v-list-item-title>
                        </template>
                            <v-list-item v-for="(colorLayoutMaster, v) in colorLayout" :key="v" :to="colorLayoutMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="colorLayoutMaster.text"> </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- COLOR PERSPECTIVE MASTER -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(カラーパース) Color Perspective</v-list-item-title>
                        </template>
                            <v-list-item v-for="(colorPersMaster, ii) in colorPers" :key="'colorPersMaster'+ii" :to="colorPersMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="colorPersMaster.text"> </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <!-- HOUSE PRESENTATION MASTER -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(ハウス プレゼンテーション) House Presentation</v-list-item-title>
                        </template>
                            <v-list-item v-for="(housePresMaster, bb) in housePres" :key="'housePresMaster'+bb" :to="housePresMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="housePresMaster.text"> </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <!-- PROPOSAL MATERIALS FOR WEB MEETINGS -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(WEB打ち合わせ用提案資料) Proposal Materials for Web Meeting</v-list-item-title>
                        </template>
                            <v-list-item v-for="(webMeetingMaster, v) in webMeeting" :key="v" :to="webMeetingMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="webMeetingMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- ALVS REVIEW REQUEST -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(ALVS検討依頼) ALVS Review Request</v-list-item-title>
                        </template>
                            <v-list-item v-for="(alvsMaster, v) in alvsReview" :key="v" :to="alvsMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="alvsMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- STRUCTURAL PRELIMINARY REVIEW REQUEST -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(構造事前検討依頼) Structural Preliminary Review Request</v-list-item-title>
                        </template>
                            <v-list-item v-for="(structuralMaster, v) in structuralPre" :key="v" :to="structuralMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="structuralMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- PROPOSAL ELECTRICAL DRAWING REQUEST -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(提案電気図面依頼) Proposal Electrical Drawing Request</v-list-item-title>
                        </template>
                            <v-list-item v-for="(proposalElectricMaster, v) in proposalElectric" :key="v" :to="proposalElectricMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="proposalElectricMaster.text"></v-list-item-title>
                                </v-list-item-content>          
                            </v-list-item>
                    </v-list-group> -->

                    <!-- ELECTRICAL DRAWING REQUEST -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(電気図面依頼) Electrical Drawing Request</v-list-item-title>
                        </template>
                            <v-list-item v-for="(electricalDrawingMaster, v) in electricalDrawing" :key="v" :to="electricalDrawingMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="electricalDrawingMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- START OPERATION -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(着手準備) Start Operation</v-list-item-title>
                        </template>
                            <v-list-item v-for="(startOperationMaster, v) in startOperation" :key="v" :to="startOperationMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="startOperationMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- REASON FOR CHANGE -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(変更理由) Reason For Change</v-list-item-title>
                        </template>
                            <v-list-item v-for="(reasonForMaster, v) in reasonFor" :key="v" :to="reasonForMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="reasonForMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->
        
        <!-- BASIC INFORMATION MASTER -->
                <div style="font-family:Arial;font-size:16px;color:#696969;" class="mt-4 ml-2">Basic Information Master</div>
                    
                    <!-- FIRE PROTECTION MASTER -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(防火仕様) Fire Protection</v-list-item-title>
                        </template>
                            <v-list-item v-for="(fireProtectionMaster, cc) in fireProtection" :key="'fireProtectionMaster'+cc" :to="fireProtectionMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="fireProtectionMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <!-- HEAVY SNOW SPECIFICATION -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(豪雪仕様) Heavy Snow Specification</v-list-item-title>
                        </template>
                            <v-list-item v-for="(heavySnowMaster, v) in heavySnow" :key="v" :to="heavySnowMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="heavySnowMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->
                    
                    <!-- SITE INFORMATION -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(敷地情報) Site Information</v-list-item-title>
                        </template>
                            <v-list-item v-for="(siteInfoMaster, v) in siteInfo" :key="v" :to="siteInfoMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="siteInfoMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- VERTICAL SNOWFALL -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(基準風速※) Vertical Snowfall*</v-list-item-title>
                        </template>
                            <v-list-item v-for="(verticalSnowMaster, v) in verticalSnow" :key="v" :to="verticalSnowMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="verticalSnowMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- STANDARD WIND SPEED -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(基準風速※) Standard Wind Speed*</v-list-item-title>
                        </template>
                            <v-list-item v-for="(standardWindwMaster, v) in standardWind" :key="v" :to="standardWindwMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="standardWindwMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- POWER COMPANY NAME -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(電力会社名) Power Company Name</v-list-item-title>
                        </template>
                            <v-list-item v-for="(powerCompanyMaster, v) in powerCompany" :key="v" :to="powerCompanyMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="powerCompanyMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- DOUBLE EARTHQUAKE RESISTANCE -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(電力会社名) Double Earthquake Resistance</v-list-item-title>
                        </template>
                            <v-list-item v-for="(doubleResistanceMaster, dd) in doubleResistance" :key="'doubleResistanceMaster'+dd" :to="doubleResistanceMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="doubleResistanceMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <!-- HIGH FIREPROOF OUTER WALL -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(耐水害住宅) High Fireproof Outer Wall</v-list-item-title>
                        </template>
                            <v-list-item v-for="(highFireproofMaster, ee) in highFireproof" :key="'highFireproofMaster'+ee" :to="highFireproofMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="highFireproofMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                    <!-- FLOOD RESISTANT HOUSING -->
                    <!-- <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(高防火外壁) Flood Resistant Housing</v-list-item-title>
                        </template>
                            <v-list-item v-for="(floodResistantMaster, v) in floodResistant" :key="v" :to="floodResistantMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="floodResistantMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group> -->

                    <!-- REMARKS COLUMN -->
                    <v-list-group prepend-icon="mdi-home">
                        <template v-slot:activator>
                            <v-list-item-title style="font-family:Arial, Helvetica, sans-serif;font-size:14px;">(備考欄) Remarks Column</v-list-item-title>
                        </template>
                            <v-list-item v-for="(remarksColumnMaster, ff) in remarksColumn" :key="'remarksColumnMaster'+ff" :to="remarksColumnMaster.to">
                                <v-list-item-content>
                                    <v-list-item-title v-text="remarksColumnMaster.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                    </v-list-group>

                <div style="font-family:Arial;font-size:16px;color:#696969;" class="mt-4 ml-2">Other Master</div>
                    <v-list-item
                        v-for="(file, iii) in files"
                        :key="iii"
                        :href="file.to"
                        link>
                    <v-list-item-icon>
                            <v-icon v-text="file.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="file.text">
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
            </v-list>
    </v-navigation-drawer>
</template>
<script>
import { mapState ,  mapActions } from 'vuex'
export default {
    name: 'MasterAppDrawer',
    props:{
        drawer:{
            type: Boolean
        }
    },
    data() {
        return {
            drawerVal: this.drawer,
            searchField: '',

        // CAD REQUEST EXCEL FILE
            files: [
                {text:'CAD Request Excel File', icon:'mdi-clipboard-file-outline', to:'cad_excel'},
        // CAD REQUEST STOP LISTS
                {text: 'CAD Request Manual', icon:'mdi-help-circle-outline', to:'cad_manual'},
                {text: '(施工連絡) Sekou', icon:'mdi-book-open-blank-variant', to:'sekou'},
                {text: 'Boss Codes', icon:'mdi-book-open-blank-variant', to:'boss_codes'},
        // HRD CALENDAR
                {text: 'HRD Calendar', icon:'mdi-calendar', to:'hrd_calendar'},
        // PH6 PLANNER MASTER
                {text: 'PH6 Planner Master', icon:'mdi-book-open-blank-variant', to:'planner_master'},       
            ],


        // DOCUMENT REQUEST MASTER
            houseType : [
                {text:'(建物タイプ) House Types', icon:'mdi-home', to:'house_types'},
                {text:'(建物タイプ 範疇) House Types Categories', icon:'mdi-home', to:'house_type_categories'},
                {text:'(建物タイプ 備考) House Type Remarks', icon:'mdi-home', to:'house_type_remarks'},
                {text:'(建物タイプグループ) House Type Group', icon:'mdi-home', to:'house_type_group'},
                {text:'(矩計) Kanabakari Setting', icon:'mdi-home', to:'kanabakari_settings'},
            ],

            items : [
                {text:'(カラー配置図) Color Layout Selection', icon:'mdi-home', to:'color_selection_layout'},
            ],

            sash : [
                {text:'(サッシﾀｲﾌﾟ) Sash Type', icon:'mdi-home', to:'sash_type'},
                {text:'(サッシ 強化) Sash Reinforcement', icon:'mdi-home', to:'sash_reinforcement'},
                {text:'(サッシ 部品) Sash Accessories', icon:'mdi-home', to:'sash_accessories'},
            ],   

            colorPers : [
                {text:'(屋根) Roof Selection', icon:'mdi-home', to:'roof_selection'},
                {text:'(レナラックⅠ吹付) Spray Lena Rack I', icon:'mdi-home', to:'spray_lena'},
                {text:'(シポストーン厚吹) Spray Shipo Stone Atsushi', icon:'mdi-home', to:'spray_shipo'},
                {text:'(シナジオ・ｉ) Synagio I', icon:'mdi-home', to:'synagio'},
                {text:'(シポロックリシン) Spray Siporoks', icon:'mdi-sprinkler', to:'siporoks'},
                {text:'(櫛引柄デザインサイディング) Spray Comb Designs', icon: 'mdi-vector-combine', to: 'comb_designs'},
                {text:'(吹付け) Spray Items', icon:'mdi-home', to:'spray_items'},
                {text:'(外壁タイル) Tile Colors', icon:'mdi-home', to:'tile_colors'},
                {text:'(外壁仕上げ) Tile External', icon:'mdi-home', to:'tile_external'},
                {text:'(外壁タイル 組合せ) Tile Colors Combinations', icon:'mdi-home', to:'tile_combinations'},
                {text:'(ルーバー木目調) Louver Woods', icon: 'mdi-solar-panel-large', to: 'louver_woods'},
                {text:'(ルーバー塗装仕上げ) Louver Paints', icon: 'mdi-brush-variant', to: 'louver_paints'},
                // {text:'(ルーバー) Louver Items', icon: 'mdi-window-shutter', to: 'louver_items'},
                {text:'(サッシ 選択) Sash Color', icon:'mdi-home', to:'sash_selection'},
                {text:'(玄関ドア) Entrance Door', icon:'mdi-home', to:'entrance_door'},
                {text:'(モール・矢切飾り) Molding Selection', icon:'mdi-form-select', to:'molding_selection'},
                {text:'(バルコニー帯) Balcony Belt Makeup Tiles Faces', icon:'mdi-balcony', to:'balcony_belt_makeup_tiles'},
                {text:'(軒天) ColorPers Eaves', icon:'mdi-home-roof', to:'eaves_selections'},
                {text:'(破風) ColorPers Gables', icon:'mdi-home-roof', to:'gable_selections'},
                {text:'(軒樋) Eaves Gutter', icon:'mdi-home-roof', to:'eaves_gutter_selections'},
                {text:'(土台水切り) ColorPers Base Drainers', icon: 'mdi-countertop', to: 'base_drainers'},
                {text:'(ポーチタイル) Porch Tiles', icon:'mdi-home', to:'porch_tiles'},
                {text:'(ポーチの色) Porch Color', icon:'mdi-home', to:'porch_colors'},
                {text:'(視点方向) ColorPers View Directions', icon:'mdi-directions', to:'view_direction_selections'},
                {text:'(視点高さ) ColorPers View Heights', icon: 'mdi-ruler', to:'view_height_selections'},
                {text:'ColorPers Column', icon: 'mdi-ruler', to:'color_pers_column'},
                //EXCESS
                // {text:'(ファノーバ 玄関ドア) Fanova Entrance Door', icon:'mdi-door-sliding', to:'fanova_entrance'},
                // {text:'(プロノーバ) Pronova', icon:'mdi-door-sliding', to:'pronova_door'},
                
            ],

            housePres : [
                {text:'(造作色) Feature Color Selection', icon:'mdi-format-color-fill', to:'feature_color'},
                {text:'(建具色) Joinery Color Selection', icon:'mdi-format-color-fill', to:'joinery_color_selection'},
                {text:'(フローリング ) Flooring Selection', icon:'mdi-floor-plan', to:'flooring_selections'},
                {text:'(階段色) HP Stairs', icon: 'mdi-cube-unfolded', to: 'hp_stairs'},
                {text:'(畳) Tatami', icon: 'mdi-cube-unfolded', to: 'tatami'},
                {text:'(キッチンセット) HP Kitchen Sets', icon: 'mdi-countertop', to: 'kitchen_sets'},
                {text:'(キッチンカウンター) HP Kitchen Counters', icon: 'mdi-countertop', to: 'kitchen_counters'},
                {text:'(スリットスライダー) HP Slitsliders', icon: 'mdi-countertop', to: 'slit_sliders'},
                {text:'(石目柄フロア) HP Stone Pattern', icon: 'mdi-countertop', to: 'stone_patterns'},
                {text:'(吊押入ユニット) HP Hanging Closet Lattices', icon: 'mdi-countertop', to: 'hanging_closet_lattices'},
                {text:'(格子引き戸) HP Lattice Sliding Door', icon: 'mdi-countertop', to: 'lattice_sliding'},
                {text:'HP Selections', icon: 'mdi-countertop', to: 'hp_columns'},
                // {text:'(階段色(smile,cube)) HP Smile Cube Stairs', icon: 'mdi-cube-unfolded', to: 'smile_cube_stairs'},
                // {text:'(階段色(jiku)) HP Jiku Stairs', icon: 'mdi-cube-unfolded', to: 'jiku_stairs'},
                // {text:'(キッチンセット(smile)) HP Smile Kitchen Sets', icon: 'mdi-countertop', to: 'smile_kitchen_sets'},
                // {text:'(キッチンセット(smart)) HP Grand Kitchen Sets', icon: 'mdi-countertop', to: 'grand_kitchen_sets'},
                // {text:'(キッチンカウンター(smart)) HP Smart Kitchen Counters', icon: 'mdi-countertop', to: 'smart_kitchen_counters'},
                // {text:'(キッチンカウンター(grand)) HP Grand Kitchen Counters', icon: 'mdi-countertop', to: 'grand_kitchen_counters'},
                // {text:'(フローリング (cube)) Cube Flooring Selection', icon:'mdi-floor-plan', to:'cube_flooring_selection'},
                // {text:'(フローリング(grand)) Grand Flooring Selection', icon:'mdi-floor-plan', to:'grand_flooring_selection'},
                // {text:'(フローリング(jiku)) Jiku Flooring Selection', icon:'mdi-floor-plan', to:'jiku_flooring_selection'},
                // {text:'(フローリング(smart)) Smart Flooring Selection', icon:'mdi-floor-plan', to:'smart_flooring_selection'},
                // {text:'(フローリング(smile)) Smile Flooring Selection', icon:'mdi-floor-plan', to:'smile_flooring_selection'},
                // {text:'(階段色(smart,grand)) Smart Grand Stair', icon:'mdi-stairs', to:'smart_grand_stair'},
            ],

            // webMeeting : [],
            // alvsReview : [],
            // structuralPre : [],
            // proposalElectric : [],
            // electricalDrawing : [],
            // startOperation : [],
            // reasonFor : [],
        
        // BASIC INFORMATION MASTER
            
            fireProtection : [
                {text:'(防火ドア ファノーバ) Fire Proof Fanova', icon:'mdi-door-sliding', to:'fireproof_fanovas'},
            ],
            // heavySnow : [],
            // siteInfo : [],
            // verticalSnow : [],
            // standardWind : [],
            // powerCompany : [],
            doubleResistance : [
                {text:'(あり/なし) Ari/Nashi', icon:'mdi-home', to:'ari_nashi'},
            ],

            highFireproof : [
                {text:'(あり/なし) Ari/Nashi', icon:'mdi-home', to:'ari_nashi'},
            ],

            floodResistant : [],

            remarksColumn : [
                {text:'(備考欄) Remarks', icon:'mdi-home', to:'remarks'},
            ],

            
            
            // items:[
                // {text:'(外壁タイル) Tile Colors', icon:'mdi-home', to:'tile_colors'},
                // {text:'(外壁タイル 組合せ) Tile Colors Combinations', icon:'mdi-home', to:'tile_combinations'},
                // {text:'(建物タイプ) House Types', icon:'mdi-home', to:'house_types'},
                // {text:'(建物タイプ 範疇) House Types Categories', icon:'mdi-home', to:'house_type_categories'},
                // {text:'(バルコニー帯) Balcony Belt Makeup Tiles Faces', icon:'mdi-balcony', to:'balcony_belt_makeup_tiles'},
                // {text:'(軒天) ColorPers Eaves', icon:'mdi-home-roof', to:'eaves_selections'},
                // {text:'(破風) ColorPers Gables', icon:'mdi-home-roof', to:'gable_selections'},
                // {text:'(視点方向) ColorPers View Directions', icon:'mdi-directions', to:'view_direction_selections'},
                // {text:'(視点高さ) ColorPers View Heights', icon: 'mdi-ruler', to:'view_height_selections'},
                // {text:'(ルーバー) Louver Items', icon: 'mdi-window-shutter', to: 'louver_items'},
                // {text:'(ルーバー木目調) Louver Woods', icon: 'mdi-solar-panel-large', to: 'louver_woods'},
                // {text:'(ルーバー塗装仕上げ) Louver Paints', icon: 'mdi-brush-variant', to: 'louver_paints'},
                // {text:'(櫛引柄デザインサイディング) Spray Comb Designs', icon: 'mdi-vector-combine', to: 'comb_designs'},
                // {text:'(シポロックリシン) Spray Siporoks', icon:'mdi-sprinkler', to:'siporoks'},
                // {text:'(屋根) Roof Selection', icon:'mdi-home', to:'roof_selection'},
                // {text:'(カラー配置図) Color Selection Layout', icon:'mdi-home', to:'color_selection_layout'},
                // {text:'(サッシ) Sash Type', icon:'mdi-home', to:'sash_type'},
                // {text:'(サッシ 強化) Sash Reinforcement', icon:'mdi-home', to:'sash_reinforcement'},
                // {text:'(サッシ 部品) Sash Accessories', icon:'mdi-home', to:'sash_accessories'},
                // {text:'(サッシ 選択) Sash Selection', icon:'mdi-home', to:'sash_selection'},
                // {text:'(吹付け) Spray Items', icon:'mdi-home', to:'spray_items'},
                // {text:'(レナラックⅠ吹付) Spray Lena Rack I', icon:'mdi-home', to:'spray_lena'},
                // {text:'(シポストーン厚吹) Spray Shipo Stone Atsushi', icon:'mdi-home', to:'spray_shipo'},
                // {text:'(シナジオ・ｉ) Synagio I', icon:'mdi-home', to:'synagio'},
                // {text:'(階段色(smile,cube)) HP Smile Cube Stairs', icon: 'mdi-cube-unfolded', to: 'smile_cube_stairs'},
                // {text:'(階段色(jiku)) HP Jiku Stairs', icon: 'mdi-cube-unfolded', to: 'jiku_stairs'},
                // {text:'(キッチンセット) HP Kitchen Sets', icon: 'mdi-countertop', to: 'kitchen_sets'},
                // {text:'(キッチンセット(smile)) HP Smile Kitchen Sets', icon: 'mdi-countertop', to: 'smile_kitchen_sets'},
                // {text:'(キッチンセット(smart)) HP Grand Kitchen Sets', icon: 'mdi-countertop', to: 'grand_kitchen_sets'},
                // {text:'(キッチンカウンター(smart)) HP Smart Kitchen Counters', icon: 'mdi-countertop', to: 'smart_kitchen_counters'},
                // {text:'(キッチンカウンター(grand)) HP Grand Kitchen Counters', icon: 'mdi-countertop', to: 'grand_kitchen_counters'},
                // {text:'(スリットスライダー) HP Slitsliders', icon: 'mdi-countertop', to: 'slit_sliders'},
                // {text:'(石目柄フロア) HP Stone Pattern', icon: 'mdi-countertop', to: 'stone_patterns'},
                // {text:'(吊押入ユニット) HP Hanging Closet Lattices', icon: 'mdi-countertop', to: 'hanging_closet_lattices'},
                // {text:'(土台水切り) ColorPers Base Drainers', icon: 'mdi-countertop', to: 'base_drainers'},
                // {text:'(モール・矢切飾り) Molding Selection', icon:'mdi-form-select', to:'molding_selection'},
                // {text:'(ファノーバ 玄関ドア) Fanova Entrance Door', icon:'mdi-door-sliding', to:'fanova_entrance'},
                // {text:'(防火ドア ファノーバ) Fire Proof Fanova', icon:'mdi-door-sliding', to:'fireproof_fanovas'},
                // {text:'(プロノーバ) Pronova', icon:'mdi-door-sliding', to:'pronova_door'},
                // {text:'(造作色) Feature Color Selection', icon:'mdi-format-color-fill', to:'feature_color'},
                // {text:'(建具色) Joinery Color Selection', icon:'mdi-format-color-fill', to:'joinery_color_selection'},
                // {text:'(フローリング(smart)) Smart Flooring Selection', icon:'mdi-floor-plan', to:'smart_flooring_selection'},
                // {text:'(フローリング(smile)) Smile Flooring Selection', icon:'mdi-floor-plan', to:'smile_flooring_selection'},
                // {text:'(フローリング (cube)) Cube Flooring Selection', icon:'mdi-floor-plan', to:'cube_flooring_selection'},
                // {text:'(フローリング(jiku)) Jiku Flooring Selection', icon:'mdi-floor-plan', to:'jiku_flooring_selection'},
                // {text:'(フローリング(grand)) Grand Flooring Selection', icon:'mdi-floor-plan', to:'grand_flooring_selection'},
                // {text:'(階段色(smart,grand)) Smart Grand Stair', icon:'mdi-stairs', to:'smart_grand_stair'},
                // {text:'(あり/なし) Ari/Nashi', icon:'mdi-home', to:'ari_nashi'},
                // {text:'(備考欄) Remarks', icon:'mdi-home', to:'remarks'},
                // {text:'(建物タイプ 備考) House Type Remarks', icon:'mdi-home', to:'house_type_remarks'},
                // {text:'(玄関ドア) Entrace Door', icon:'mdi-home', to:'entrance_door'},
                // {text:'(ポーチの色) Porch Color', icon:'mdi-home', to:'porch_colors'},
                // {text:'(ポーチタイル) Porch Tiles', icon:'mdi-home', to:'porch_tiles'},
            // ],
        // items:[
            //     {text:'Tile Colors', icon:'mdi-home', to:'tile_colors'},
            //     {text:'Tile Colors Combinations', icon:'mdi-home', to:'tile_combinations'},
            //     {text:'House Types', icon:'mdi-home', to:'house_types'},
            //     {text:'House Types Categories', icon:'mdi-home', to:'house_type_categories'},
            //     {text:'Balcony Belt Makeup Tiles Faces', icon:'mdi-balcony', to:'balcony_belt_makeup_tiles'},
            //     {text:'ColorPers Eaves', icon:'mdi-home-roof', to:'eaves_selections'},
            //     {text:'ColorPers Gables', icon:'mdi-home-roof', to:'gable_selections'},
            //     {text:'ColorPers View Directions', icon:'mdi-directions', to:'view_direction_selections'},
            //     {text:'ColorPers View Heights', icon: 'mdi-ruler', to:'view_height_selections'},
            //     {text:'Louver Items', icon: 'mdi-window-shutter', to: 'louver_items'},
            //     {text:'Louver Woods', icon: 'mdi-solar-panel-large', to: 'louver_woods'},
            //     {text:'Louver Paints', icon: 'mdi-brush-variant', to: 'louver_paints'},
            //     {text:'Spray Comb Designs', icon: 'mdi-vector-combine', to: 'comb_designs'},
            //     {text:'Spray Siporoks', icon:'mdi-sprinkler', to:'siporoks'},
            //     {text:'Roof Selection', icon:'mdi-home', to:'roof_selection'},
            //     {text:'Color Selection Layout', icon:'mdi-home', to:'color_selection_layout'},
            //     {text:'Sash Type', icon:'mdi-home', to:'sash_type'},
            //     {text:'Sash Reinforcement', icon:'mdi-home', to:'sash_reinforcement'},
            //     {text:'Sash Accessories', icon:'mdi-home', to:'sash_accessories'},
            //     {text:'Sash Selection', icon:'mdi-home', to:'sash_selection'},
            //     {text:'Spray Items', icon:'mdi-home', to:'spray_items'},
            //     {text:'Spray Lena Rack I', icon:'mdi-home', to:'spray_lena'},
            //     {text:'Spray Shipo Stone Atsushi', icon:'mdi-home', to:'spray_shipo'},
            //     {text:'Synagio I', icon:'mdi-home', to:'synagio'},
            //     {text:'HP Smile Cube Stairs', icon: 'mdi-cube-unfolded', to: 'smile_cube_stairs'},
            //     {text:'HP Jiku Stairs', icon: 'mdi-cube-unfolded', to: 'jiku_stairs'},
            //     {text:'HP Kitchen Sets', icon: 'mdi-countertop', to: 'kitchen_sets'},
            //     {text:'HP Smile Kitchen Sets', icon: 'mdi-countertop', to: 'smile_kitchen_sets'},
            //     {text:'HP Grand Kitchen Sets', icon: 'mdi-countertop', to: 'grand_kitchen_sets'},
            //     {text:'HP Smart Kitchen Counters', icon: 'mdi-countertop', to: 'smart_kitchen_counters'},
            //     {text:'HP Grand Kitchen Counters', icon: 'mdi-countertop', to: 'grand_kitchen_counters'},
            //     {text:'HP Slitsliders', icon: 'mdi-countertop', to: 'slit_sliders'},
            //     {text:'HP Stone Pattern', icon: 'mdi-countertop', to: 'stone_patterns'},
            //     {text:'HP Hanging Closet Lattices', icon: 'mdi-countertop', to: 'hanging_closet_lattices'},
            //     {text:'ColorPers Base Drainers', icon: 'mdi-countertop', to: 'base_drainers'},
            //     {text:'Molding Selection', icon:'mdi-form-select', to:'molding_selection'},
            //     {text:'Fanova Entrance Door', icon:'mdi-door-sliding', to:'fanova_entrance'},
            //     {text:'Fire Proof Fanova', icon:'mdi-door-sliding', to:'fireproof_fanovas'},
            //     {text:'Pronova', icon:'mdi-door-sliding', to:'pronova_door'},
            //     {text:'Feature Color Selection', icon:'mdi-format-color-fill', to:'feature_color'},
            //     {text:'Joinery Color Selection', icon:'mdi-format-color-fill', to:'joinery_color_selection'},
            //     {text:'Smart Flooring Selection', icon:'mdi-floor-plan', to:'smart_flooring_selection'},
            //     {text:'Smile Flooring Selection', icon:'mdi-floor-plan', to:'smile_flooring_selection'},
            //     {text:'Cube Flooring Selection', icon:'mdi-floor-plan', to:'cube_flooring_selection'},
            //     {text:'Jiku Flooring Selection', icon:'mdi-floor-plan', to:'jiku_flooring_selection'},
            //     {text:'Grand Flooring Selection', icon:'mdi-floor-plan', to:'grand_flooring_selection'},
            //     {text:'Smart Grand Stair', icon:'mdi-stairs', to:'smart_grand_stair'},
            //     {text:'Ari/Nashi', icon:'mdi-home', to:'ari_nashi'},
            //     {text:'Remarks', icon:'mdi-home', to:'remarks'},
            //     {text:'House Type Remarks', icon:'mdi-home', to:'house_type_remarks'},
            //     {text:'Entrace Door', icon:'mdi-home', to:'entrance_door'},
            //     {text:'Porch Color', icon:'mdi-home', to:'porch_colors'},
            //     {text:'Porch Tiles', icon:'mdi-home', to:'porch_tiles'},
            // ],
        }
    },

    computed:{
        ...mapState([
            'searchItem',
        ]),


        masterList(){
            if(this.searchItem){
                return _.sortBy(this.items.filter(res => res.text.toLowerCase().includes(this.searchItem.toLowerCase())), [res => res.text]);
            }
            return _.sortBy(this.items, [res => res.text]);
        }
    },
    watch: {
        drawer(val){
            console.log(val)
            this.drawerVal = val
        }
    },
    methods: {
        ...mapActions(['setSearchItem']),

        toggleDrawer(val){
            this.$emit("toggleDrawer",val)
        },

    },

    // mounted(){
    //     console.clear();
    // }
    // updated: debounce(function () {
    //     this.$nextTick(() => {
    //         if(this.firstLoad){
    //             var activeElem = document.querySelector(".active-item")
    //             if(typeof(activeElem) != 'undefined' && activeElem != null){
    //                 var elem = document.querySelector(".v-navigation-drawer__content")
    //                 var elemHeight = elem.clientHeight
    //                 var activeElemHeight = activeElem.clientHeight
    //                 elem.scrollTo(0, ((activeElem.offsetTop + activeElemHeight/2) - elemHeight/2 ))
    //             }
    //             this.firstLoad = false
    //         }
    //     })
    // }, 250),

    
}
</script>
<style scoped>
    .search_field{
        min-height: 48px;
    }

    .v-navigation-drawer .v-list{
        padding: 0px !important;
    }

    .v-navigation-drawer .v-list-item__content{
        padding: 0px !important;
    }

    .v-navigation-drawer .v-list-group__header .v-list-item--active{
        width: 410px !important;
        background-color: #1866d1;
        color:#1866d1;
    }

    .v-navigation-drawer .project_all.v-item--active.v-list-item--active{
        background-color:#e3eefa;
        color:#1866d1;
    }

    /* .v-navigation-drawer .v-list-group__header .v-list-item__title{
        font-size: 12px !important;
        font-weight: bold;
    } */

    .v-navigation-drawer .v-list-group__header .v-list-item__icon .v-icon{
        font-size: 16px !important
    }

    .v-navigation-drawer .v-list-group__items .v-list-item__title {
        font-size: 14px !important;
    }

    /* .v-navigation-drawer .v-list-group__items .v-list-item__title > span{
        font-size: 8px !important;
    } */

    .v-navigation-drawer .v-list-group__items .v-list-item{
        padding-left: 16px !important;
    }



    .v-input__slot{
        -webkit-box-align: stretch;
        align-items: stretch;
        min-height: 32px !important;
    }


</style>